import { Reveal } from "@/components/Reveal";

// Reusable overline + heading + optional description block.
export const SectionHeading = ({ overline, title, description, align = "left", light = false, className = "" }) => {
  const alignCls = align === "center" ? "text-center mx-auto items-center" : "text-left";
  return (
    <div className={`flex flex-col ${alignCls} max-w-3xl ${className}`}>
      {overline && (
        <Reveal>
          <div className={`flex items-center gap-3 mb-4 ${align === "center" ? "justify-center" : ""}`}>
            <span className={`h-px w-8 ${light ? "bg-blue-300" : "bg-[#1E40AF]"}`} />
            <span className={`text-xs font-semibold tracking-[0.25em] uppercase ${light ? "text-blue-200" : "text-[#1E40AF]"}`}>
              {overline}
            </span>
          </div>
        </Reveal>
      )}
      <Reveal custom={1}>
        <h2 className={`font-display font-bold text-3xl sm:text-4xl lg:text-[44px] leading-[1.1] tracking-tight ${light ? "text-white" : "text-[#0F172A]"}`}>
          {title}
        </h2>
      </Reveal>
      {description && (
        <Reveal custom={2}>
          <p className={`mt-5 text-lg leading-relaxed ${light ? "text-slate-300" : "text-slate-600"}`}>
            {description}
          </p>
        </Reveal>
      )}
    </div>
  );
};
